import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
	getBaseGroups,
	getBaseGroup,
	updateBaseGroup,
} from 'actions/basegroups';
import { getGroupById } from 'actions/groups';
import { Button, Icon, Block, Flex } from '@haldor/ui';
import { FormControl, Select as MuiSelect, MenuItem } from '@mui/material';
import { Spinner } from 'UI';
import Modal from 'containers/Modals/Modal';

import BaseGroupForm from 'containers/BaseGroups/Form/BaseGroupForm';

class SectionBaseGroups extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			editModal: false,
			selectedBaseGroup: 0,
		};
	}

	componentDidMount = async () => {
		const { groupId } = this.props.match.params;

		this.setState({ loading: true });
		const group = await this.props.getGroupById(groupId);
		this.props.getBaseGroups(group.id);
		this.setState({ loading: false });
	}

	/* Help methods - JHELP */
	getUnassignedStudents = () => {
		let students = [];

		if (this.props.active == null) {
			return students;
		}

		if (this.props.group == null) {
			return students;
		}

		this.props.group.members.forEach(student => {
			let isSelected = this.props.active?.units.find(unit => {
				return unit.memberships.find(member => student.userId == member.userId);
			});

			if (isSelected != null) {
				return false;
			}

			students.push(student);
		});

		return students;
	}

	/* Event methods - JEVEN */
	toggleEditModal = () => {
		this.setState({ editModal: !this.state.editModal });
	}

	onBaseGroupSubmit = (values) => {
		return new Promise(async (resolve) => {
			await this.props.updateBaseGroup(values);
			this.setState({ editModal: false, selectedBaseGroup: this.props.active?.id });

			resolve(1);
		});
	}

	onBaseGroupSelect = async (event) => {
		if (event.target.value == null || event.target.value == '') {
			this.setState({ selectedBaseGroup: '' });
			return false;
		}

		this.setState({ loading: true, selectedBaseGroup: event.target.value });
		await this.props.getBaseGroup(event.target.value);
		this.setState({ loading: false });
	}

	/* Render methods - JREND */
	renderBaseGroup = (baseGroup) => {
		return (
			<div style={{ marginTop: '1rem' }} key={baseGroup.id}>
				{baseGroup.units.map((unit, index) => {
					return <div className="unit" key={index}>
						<span className="title">
							{unit.title}
						</span>

						{unit.memberships.map((membership) => {
							return <div key={membership.userId}>
								{membership.user?.firstName} {membership.user?.lastName}
							</div>
						})}
					</div>
				})}
			</div>
		);
	}

	render() {
		const { translate } = this.props;
		const unassignedStudents = this.getUnassignedStudents();

		return (
			<div className="basegroups display">
				<Modal title={translate('edit-basegroup')} isOpen={this.state.editModal} type="small" onClose={this.toggleEditModal}>
					<div className="form">
						<div className="form-row">
							<BaseGroupForm
								group={this.props.group}
								onSubmit={this.onBaseGroupSubmit}
								baseGroup={this.props.active}
							/>
						</div>
					</div>
				</Modal>

				<Block>
					<h3 style={{ fontWeight: 400, marginBottom: '1rem' }}>
						{this.props.translate('basegroups')}
					</h3>

					<div className="form">
						<Flex center>
							<div style={{ flex: 1 }} className="select">
								<FormControl fullWidth>
									<MuiSelect sx={{ backgroundColor: '#FFFFFF' }} value={this.state.selectedBaseGroup}
										onChange={(e) => this.onBaseGroupSelect(e)}
										displayEmpty
									>
										<MenuItem value="">{this.props.translate('select-basegroup')}</MenuItem>

										{this.props.baseGroups.map((baseGroup) => {
											return (
												<MenuItem value={baseGroup.id} key={baseGroup.id}>
													{baseGroup.title}
												</MenuItem>
											)
										})}
									</MuiSelect>
								</FormControl>
							</div>

							{this.props.active != null ?
								<div style={{ flex: 0, marginLeft: '1.25rem' }}>
									<Button type="secondary" onClick={this.toggleEditModal}>
										<Icon name="Pen_Small" />
										{this.props.translate('Edit')}
									</Button>
								</div>
								: null}
						</Flex>
					</div>

					{this.state.loading ?
						<Spinner center />
						:
						this.props.active != null ?
							this.renderBaseGroup(this.props.active)
							: null
					}

					{unassignedStudents.length > 0 ?
						<div className="unit">
							<span className="title">{this.props.translate('unassigned-students')}</span>

							{unassignedStudents.map((student, index) => {
								return <div key={student.userId}>
									{student.firstName} {student.lastName}
								</div>
							})}
						</div>
						: null}
				</Block>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
		currentUser: state.user.currentUser,
		baseGroups: state.BaseGroups.baseGroups,
		active: state.BaseGroups.baseGroup,
	};
}

export default withRouter(connect(mapStateToProps, {
	getBaseGroups,
	getBaseGroup,
	updateBaseGroup,
	getGroupById,
})(SectionBaseGroups));